module.exports = __webpack_public_path__ + "media/images/indicator16-29bdafdcb4fe7c3ed3861b0fb4f70d4a.gif";